const rutasProyectoTorre2 = [
  // torre_2
  // torre_2_p1
  // torre_2_pisos
  // torre_2_ventanas
  // torre_2_balconesMuros
  // torre_2_balconesBarandas * tiene Alpha

  /// Modelos
  {
    name: "modelo_torre_2",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE02.glb",
  },  
  {
    name: "modelo_torre_2_barandas",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE02_BARANDAS.glb",
  },
  {
    name: "modelo_torre_2_ventanas",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE02_VENTANAS.glb",
  },
  
 
  ///Texturas  
  /*{
    name: "text_ejemplo",
    type: "texture",
    path: "texturas/proyecto/ejemplo.webp"
  },*/

  {
    name: "text_torre_2",
    type: "texture",
    path: "texturas/proyecto/nuevo/TORRE_02_DiffuseColor.webp"
  },
  //  
  {
    name: "text_torre_2_barandas",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE 02_BALCONES_BARANDAS_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_2_ventanas",
    type: "texture",
    path: "texturas/proyecto/nuevo/TORRE02_VENTANAS_Corona_DiffuseColor.webp"
  },  
];

export default rutasProyectoTorre2;
